import { Component, contentChildren, EventEmitter, Output } from '@angular/core';
import { ResultItemDirective } from '../directives/result-item.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cec-result-summary',
  templateUrl: './result-summary.component.html',
  styleUrls: ['./result-summary.component.scss'],
  imports: [ResultItemDirective, TranslateModule],
  standalone: true,
})
export class ResultSummaryComponent {

  /** Defines toolbar items in HTML */
  public items = contentChildren(ResultItemDirective);

  @Output()
  public onButtonClicked = new EventEmitter<string>();

  public onClickButton(id: string): void {
    this.onButtonClicked.emit(id);
  }
}
